import type { ApiRoute, NoBody } from "../api"
import type { CustomerNameView } from "../common/customer/CustomerNameView"

export interface GetCustomerNamePathParams {
	businessPartnerId: string
}

export interface GetCustomerNameQueryParams {
	capSamlToken: string
}

export const getCustomerNameRoute: ApiRoute<
	GetCustomerNamePathParams,
	GetCustomerNameQueryParams,
	NoBody,
	CustomerNameView
> = {
	buildUrl: (params) => `/customer/${params.businessPartnerId}/name`,
	method: "get",
	path: "/customer/:businessPartnerId/name",
}
